import React from 'react'
import styled from 'react-emotion'
import { css } from 'emotion'

import IsometricHero from './hero_vector'
import Button from '../buttons/Button'

import HTRBanner from '../../assets/whistle-top-rated-x2.png'
import RegisterButton from '../buttons/RegisterButton'


const HeroWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;

  @media (min-width: 1025px) {
    flex-direction: row;
	}
`

const HeroSubheader = styled.h2`
  font-size: 1.125rem;
  font-weight: 300;
  font-family: 'Roboto';
  line-height: 1.5rem;
  margin-top: 2.5rem;
`

const HeaderWrapper = styled.div`
  flex: 2 400px;
  margin-top: 2rem;
  @media (min-width: 1025px) {
		margin-top: 0;
	}
`

const VectorWrapper = styled.div`
  flex: 3 280px;
  @media (min-width: 1025px) {
    padding-left: 1rem;
    align-self: center;
	}
`

const CTAWrapper = styled.div`
  margin-top: 2.5rem;
`
const button2Style = css`
  // margin-left: 1rem;
  
`

const anchor = css`
  margin-top: 1.5rem;
  color: #984983;
  display: block;
  font-size: 0.9rem;
  font-weight: 300;
  font-family: 'Roboto';
  line-height: 1.5rem;
  text-align: center;
  display: flex;
  &:hover {
    cursor: pointer;
  }
  @media (min-width: 800px) {
    text-align: left;
    font-size: 1.125rem;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-evenly;
  button {
    margin-bottom: 1rem;
  }
  a {
    margin-bottom: 1rem;
  }
  @media (min-width: 800px) {
		margin-right: 2rem;
  }

  @media (min-width: 1450px) {
    justify-content: space-between;
  }
`

const anchorText = css`
  text-decoration: underline;
`

const HTRImage = styled.img`
  width: 90%;
  margin: 2rem auto;
  display: block;
  @media (min-width: 800px) {
    margin: 2rem 0rem 2rem;
  }
`

const FileIconLinkClass = css`
  vertical-align: middle;
  margin-right: 0.5rem;
  text-decoration: none;
`

const Hero = (props) => {

  return (
    <HeroWrapper>
      <HeaderWrapper>
        {props.children}
        <h1>{props.header}</h1>
        <HeroSubheader>{props.subHeader}</HeroSubheader>
        <CTAWrapper>
          <ButtonContainer>
            <Button to="/schedule">Schedule Demo</Button>
            <RegisterButton />
            <Button to="" secondary onClick={() => props.toggleVideo()}>See How It Works</Button>
          </ButtonContainer>
          <a href="https://hoteltechreport.com/company/whistle" target="_blank">
            <HTRImage src={HTRBanner}/>
          </a>
          <a href="https://whistle-ebook.paperform.co" target="_blank" className={anchor} download>
            <i className={`${FileIconLinkClass} material-icons`}>menu_book</i>
            <span className={anchorText}>2020 Guest Messaging e-Book</span>
          </a>
          <a href="https://gmpbuyersguide.paperform.co" target="_blank" className={anchor}>
            <i className={`${FileIconLinkClass} material-icons`}>file_copy</i>
            <span className={anchorText}>2020 Guest Messaging Software Buyer's Guide</span>
          </a>
        </CTAWrapper>
      </HeaderWrapper>
      <VectorWrapper>
        <IsometricHero />
      </VectorWrapper>
    </HeroWrapper>
  )
}
 
export default Hero;


// WEBPACK FOOTER //
// ./src/components/main/hero.js